<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box" v-if="ay_std_div_list != null">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong>Send SMS to students</strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-row justify="center" dense>
        <v-col sm="2">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="sel_ay_data"
            return-object
            :items="ay_std_div_list"
            item-text="ay"
            label="Academic Year"
            outlined
            @change="getStd()"
            @click="putnull"
          />
        </v-col>
        <v-col sm="2" v-if="std_div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="sel_std_data"
            return-object
            :items="std_div_list"
            item-text="std"
            label="Standard"
            outlined
            @change="getDiv"
            @click="putnull"
          />
        </v-col>
        <v-col sm="2" v-if="div_list != null">
          <v-icon color="error">*</v-icon>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="div"
            return-object
            :items="div_list"
            item-text="div_name"
            label="Division"
            outlined
            @click="putnull"
          />
        </v-col>

        <v-col sm="2" v-if="sel_ay_data && sel_std_data">
          <v-btn
            class="mt-6 button"
            @click="getStudents()"
            :loading="fetch_loader"
            >Fetch</v-btn
          >
        </v-col>
      </v-row>
      <span v-if="mainList != '' && mainList != null">
        <!-- <download-excel
          class="mr-2 pb-3 pt-2"
          :data="mainList"
          :fields="table_fields"
          worksheet="Student_List"
          name="SubjectRegistrationData.xls"
        >
          <v-btn color="success" outlined rounded>
            <v-icon dark>mdi-file-excel</v-icon> Export
          </v-btn>
        </download-excel> -->
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            show-select
            v-if="mainList.length > 0"
            :headers="headers1"
            :items="mainList"
            :search="search"
            class="elevation-1"
            v-model="selected"
            item-key="ld_id"
          >
          </v-data-table>
        </v-card>
      </span>
      <v-row class="justify-center">
        <v-btn
          v-if="mainList != '' && mainList != null"
          class="button"
          :loading="fetch_loader"
          @click="nextpage"
          >Send SMS <v-icon>mdi-cellphone-message</v-icon></v-btn
        >
      </v-row>
    </v-card>
    <!-- <v-card v-if="opencomposewindow">
      <v-row class="justify-center">
        <v-btn class="button" :loading="fetch_loader" @click="openSMSBox"
          >Send SMS <v-icon>mdi-cellphone-message</v-icon></v-btn
        >
      </v-row>
    </v-card> -->
    <v-row class="justify-center">
      <v-dialog v-model="failsmsdailog" width="700px">
        <v-card>
          <v-card-title>
            <span
              >Following students have not received SMS, please try again!</span
            >
          </v-card-title>
          <v-card-text>
            <v-data-table
              v-if="failed_sms_student_list.length > 0"
              :headers="headers3"
              :items="failed_sms_student_list"
              :search="search"
              class="elevation-1"
            >
            </v-data-table>
          </v-card-text>
          <v-row class="justify-center">
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                outlined
                text
                @click="failsmsdailog = false"
                >Cancel</v-btn
              >
            </v-card-actions>
          </v-row>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      overlay: false,
      faildailog: false,
      failsmsdailog: false,
      failed_sms_student_list: [],
      smsbody: "",
      fetch_loader: false,
      snackbar: false,
      search: "",
      snackbar_msg: "",
      color: "",
      snackbar: false,
      ay_std_div_list: null,
      sel_ay_data: null,
      std_div_list: null,
      sel_std_data: null,
      div_list: null,
      div: null,
      mainList: [],
      selected: [],
      total_students: [],
      headers1: [
        {
          text: "Sr. No.",
          value: "srno",
        },
        {
          text: "Gr No.",
          align: "center",
          value: "gr_number",
        },
        {
          text: "Student Name",
          align: "center",
          value: "student_name",
        },
        {
          text: "Standard",
          align: "center",
          value: "standard",
        },
        {
          text: "Division",
          align: "center",
          value: "division",
        },
        {
          text: "Contact No.",
          align: "center",
          value: "contactno",
        },
      ],
      headers3: [
        {
          text: "Sr. No.",
          value: "srno",
        },
        {
          text: "Student Name",
          value: "student_name",
        },
      ],
    };
  },
  methods: {
    sendsms() {
      // console.log("inside sendemail");
      const data = {
        students: this.total_students,
      };
      this.overlay = true;
      axios
        .post("/CommunicationType/sendSmsGCS", data)
        .then((res) => {
          this.overlay = false;
          this.fetch_loader = false;
          if (res.data.success_list != null) {
            this.showSnackbar(
              "success",
              "SMS has been sent successfully to all selected students..."
            ); // show snackbar
          }
          if (res.data.failed_list != null) {
            for (var i = 0; i < res.data.failed_list.length; i++) {
              this.failed_sms_student_list = res.data.failed_list;
            }
            this.showSnackbar("#ff5050", "Some student have not received SMS"); // show snackbar
            this.failsmsdailog = true;
          }
        })
        .catch((error) => {
          // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          this.fetch_loader = false;
          this.overlay = false;
        })
        .finally(() => {
          this.fetch_loader = false;
          this.overlay = false;
        });
    },
    nextpage() {
      this.total_students = [];
      for (var i = 0; i < this.selected.length; i++) {
        // console.log("selected" + this.selected[i].ld_id);
        this.total_students.push(this.selected[i].ld_id);
        // console.log("total_students: " + this.total_students);
      }
      if (this.total_students.length != 0) {
        this.sendsms();
      } else {
        this.showSnackbar("#b71c1c", "Please select students!"); // show snackbar
      }
    },
    getStd() {
      this.std_div_list = null;
      this.sel_std_data = null;
      this.div_list = null;
      this.div = null;
      this.std_div_list = ["All"];
      this.sel_std_data = "All";
      this.std_div_list = this.sel_ay_data.std_list;
      this.std_div_list.unshift("All");
    },
    getDiv() {
      // console.log("inside getDiv"+this.sel_std_data)
      if (this.sel_std_data == "All") {
        this.div_list = null;
      } else {
        this.div_list = ["All"];
        this.div = "All";
        this.div_list = this.sel_std_data.div_list;
        this.div_list.unshift("All");
        this.div = this.div_list[0];
        if (this.div_list.length == 0) {
          alert("No division found!!!");
          this.div_list = null;
        }
      }
    },
    putnull() {
      this.mainList = [];
    },
    getStudents() {
      // console.log("this.div.div_id: "+this.div)
      // console.log("this.sel_std_data: "+this.sel_std_data)
      let formData;
      this.fetch_loader = true;
      let ay;
      let div;
      let standard;

      if (this.sel_std_data == "All") {
        // console.log("inside this.div == null")
        //"All" option in standard is selected
        ay;
        standard = this.sel_std_data;

        if (this.sel_ay_data.ay_id) {
          ay = this.sel_ay_data.ay_id;
        } else if (this.sel_ay_data.id) {
          ay = this.sel_ay_data.id;
        }

        formData = {
          ay: ay,
          standard: standard,
        };
        // console.log(": "+formData.ay)
        // console.log(": "+formData.standard)
      } else {
        //  console.log("inside particular standard and division is selected ")
        //particular standard and division is selected
        ay;
        div = this.div.div_id;
        standard = this.sel_std_data.std_id;

        if (this.sel_ay_data.ay_id) {
          ay = this.sel_ay_data.ay_id;
        } else if (this.sel_ay_data.id) {
          ay = this.sel_ay_data.id;
        }
        if (this.div.div_id) {
          div = this.div.div_id;
        } else {
          div = this.div;
        }

        formData = {
          ay: ay,
          division: div,
          standard: standard,
        };
        // console.log(": "+formData.ay)
        // console.log(": "+formData.standard)
        // console.log(": "+formData.division)
      }
      axios
        .post("/CommunicationType/getStudents", formData)
        .then((res) => {
          if (res.data.student_list.length != 0) {
            this.mainList = res.data.student_list;
            this.fetch_loader = false;
          } else {
            this.showSnackbar("#b71c1c", "No data found!"); // show snackbar
            this.mainList = null;
            this.fetch_loader = false;
          }
        })
        .catch((error) => {
          // this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          this.fetch_loader = false;
        })
        .finally(() => {
          ay = null;
          this.fetch_loader = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onload() {
      axios
        .post("/commonAPI/get_ay_std_div")
        .then((res) => {
          this.ay_std_div_list = res.data.data;
          this.sel_ay_data = res.data.curr_ay;
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.onload();
  },
};
</script>

<style>
</style>